import { render, staticRenderFns } from "./receivableAdjustmentLineComponent.vue?vue&type=template&id=4cb010b0&scoped=true&"
import script from "./receivableAdjustmentLineComponent.vue?vue&type=script&lang=js&"
export * from "./receivableAdjustmentLineComponent.vue?vue&type=script&lang=js&"
import style0 from "./receivableAdjustmentLineComponent.vue?vue&type=style&index=0&id=4cb010b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb010b0",
  null
  
)

export default component.exports